import { IMG_BASE_URL } from "@vahak/core/dist/constants/misc";
import { ROUTES } from "@vahak/core/dist/constants/routeStrings";
import { PLATFORM_STATS, getPlatformStatI18nLabels } from "@vahak/core/dist/constants/platformStats";
import { getTransporterFigure, getTransporterFigureTypes } from "@vahak/core/dist/methods/getTransporterFigure";

import { useTranslation } from "next-i18next";

export const useCustomerSaysData = () => {
    const { t } = useTranslation(["whyChooseUs"]);

    const customerSaysData = [
        {
            id: 0,
            name: t("our_customer_says.aay_khodiyar"),
            company: t("our_customer_says.jay_khodiyar_company"),
            location: t("our_customer_says.ahmedabad"),
            massage: t("our_customer_says.ayy_khodiyar_massage"),
            image: `testimonials_6_desktop_1x.jpg`
        },
        {
            id: 1,
            name: t("our_customer_says.sachin_kumar"),
            company: t("our_customer_says.sachin_kumar_company"),
            location: "",
            massage: t("our_customer_says.sachin_kumar_massage"),
            image: `testimonials_5_desktop_1x.jpg`
        },
        {
            id: 2,
            name: t("our_customer_says.kalpesh_somase"),
            company: "",
            location: t("our_customer_says.kalpesh_location"),
            massage: t("our_customer_says.kalpesh_massage"),
            image: `testimonials_4_desktop_1x.jpg`
        },
        {
            id: 3,
            name: t("our_customer_says.satyam_vyas"),
            company: t("our_customer_says.satyam_company"),
            location: t("our_customer_says.satyam_location"),
            massage: t("our_customer_says.satyam_massage"),
            image: `testimonials_3_desktop_1x.jpg`
        },
        {
            id: 4,
            name: t("our_customer_says.arpit"),
            company: t("our_customer_says.arpit_company"),
            location: t("our_customer_says.arpit_location"),
            massage: t("our_customer_says.arpit_massage"),
            image: `testimonials_2_desktop_1x.jpg`
        },
        {
            id: 5,
            name: t("our_customer_says.mohammed_f"),
            company: t("our_customer_says.mohammed_f_company"),
            location: t("our_customer_says.mohammed_f_location"),
            massage: t("our_customer_says.mohammed_f_massage"),
            image: `testimonials_1_desktop_1x.jpg`
        }
    ];

    return customerSaysData;
};

export const useOtbAchievement = () => {
    const { t } = useTranslation("servicePages");

    const otbAchievement = [
        {
            id: 0,
            value: `4 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-truck-booking.achievements.olbAchievement.data_1.label"),
            image: `happy_trucker_desktop.png`,
            altText: "Man resting on a truck"
        },
        {
            id: 1,
            value: "30,000+",
            label: t("servicePages:online-truck-booking.achievements.olbAchievement.data_2.label"),
            image: `loads-for-transporters_desktop.png`,
            altText: "5 carton boxes"
        },
        {
            id: 2,
            value: `2 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-truck-booking.achievements.olbAchievement.data_3.label"),
            image: `transporter-connections_desktop.png`,
            altText: "Man explaining"
        },
        {
            id: 3,
            value: "12,000+",
            label: t("servicePages:online-truck-booking.achievements.olbAchievement.data_4.label"),
            image: `indian-transport-marketplace_desktop.png`,
            altText: "Indian map with GPS pins"
        }
    ];
    return otbAchievement;
};

export const uselsAchievement = () => {
    const { t } = useTranslation("servicePages");

    const otbAchievement = [
        {
            id: 0,
            value: `20 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_1.label"),
            image: `happy_trucker_desktop.png`,
            altText: "Man resting on a truck"
        },
        {
            id: 1,
            value: `2 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_2.label"),
            image: `transporter-connections_desktop.png`,
            altText: "Man explaining"
        },
        {
            id: 2,
            value: "30,000+",
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_3.label"),
            image: `loads-for-transporters_desktop.png`,
            altText: "5 carton boxes"
        },

        {
            id: 3,
            value: PLATFORM_STATS.locations.label,
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_4.label"),
            image: `indian-transport-marketplace_desktop.png`,
            altText: "Indian map with GPS pins"
        }
    ];
    return otbAchievement;
};
export const useFtlAchievement = () => {
    const { t } = useTranslation("servicePages");

    const ftlAchievement = [
        {
            id: 0,
            value: `20 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_1.label"),
            image: `happy_trucker_desktop.png`,
            altText: "Man resting on a truck"
        },
        {
            id: 1,
            value: "30,000+",
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_3.label"),
            image: `loads-for-transporters_desktop.png`,
            altText: "5 carton boxes"
        },
        {
            id: 2,
            value: `6 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-load-booking.achievements.olbAchievement.data_3.label"),
            image: `happy_trucker_desktop.png`,
            altText: "a man leaning on a truck"
        },
        {
            id: 3,
            value: PLATFORM_STATS.locations.label,
            label: t("servicePages:online-truck-booking.achievements.otbAchievement.data_4.label"),
            image: `indian-transport-marketplace_desktop.png`,
            altText: "Indian map with GPS pins"
        }
    ];
    return ftlAchievement;
};

export const useOlbAchievement = () => {
    const { t } = useTranslation("servicePages");
    const olbAchievement = [
        {
            id: 0,
            value: `${getTransporterFigure(getTransporterFigureTypes.LAKH_NUMBER)} ${t(
                "servicePages:online-load-booking.achievements.olbAchievement.lakh"
            )}+`,
            label: t("servicePages:online-load-booking.achievements.olbAchievement.data_1.label"),
            image: `LCV-transporter-India_desktop.png`,
            altText: "trucks in a line"
        },
        {
            id: 1,
            value: `4 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-load-booking.achievements.olbAchievement.data_2.label"),
            image: `loads-for-transporters_desktop.png`,
            altText: "boxes with two leaves"
        },
        {
            id: 2,
            value: `4 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:online-load-booking.achievements.olbAchievement.data_3.label"),
            image: `happy_trucker_desktop.png`,
            altText: "a man leaning on a truck"
        },
        {
            id: 3,
            value: "25,000+",
            label: t("servicePages:online-load-booking.achievements.olbAchievement.data_4.label"),
            image: `unique_loads_desktop.png`,
            altText: "a man lifting boxes standing near a phone & a plant pot"
        }
    ];
    return olbAchievement;
};

export const useGnAchievement = () => {
    const { t } = useTranslation("servicePages");
    const gnAchievement = [
        {
            id: 0,
            value: `${getTransporterFigure(getTransporterFigureTypes.LAKH_NUMBER)} ${t(
                "servicePages:online-load-booking.achievements.olbAchievement.lakh"
            )}+`,
            label: t("servicePages:grow-network.achievements.gnAchievement.data_1.label"),
            image: `LCV-transporter-India_desktop.png`,
            altText: "truck fleet"
        },
        {
            id: 1,
            value: `10 ${t("servicePages:online-load-booking.achievements.olbAchievement.lakh")}+`,
            label: t("servicePages:grow-network.achievements.gnAchievement.data_2.label"),
            image: `downloads_desktop.png`,
            altText: "app mockup download button"
        },
        {
            id: 2,
            value: "12,000+",
            label: t("servicePages:grow-network.achievements.gnAchievement.data_3.label"),
            image: `indian-transport-marketplace_desktop.png`,
            altText: "Indian map with GPS markers"
        },
        {
            id: 3,
            value: "11,000+",
            label: t("servicePages:grow-network.achievements.gnAchievement.data_4.label"),
            image: `gst_aadhar_desktop.png`,
            altText: "GST and Aadhaar document mockup"
        }
    ];
    return gnAchievement;
};
export const usePartLoadFeatures = () => {
    const { t } = useTranslation("servicePages");

    const partLoadFeatures = [
        {
            id: 0,
            tabTitle: t("servicePages:part-load-booking.features.partLoadFeatures.data_1.tabTitle"),
            description: t("servicePages:part-load-booking.features.partLoadFeatures.data_1.description"),
            image: `PANIndiaroutes-1X-Web.png`,
            altText: "india map with loads"
        },
        {
            id: 1,
            tabTitle: t("servicePages:part-load-booking.features.partLoadFeatures.data_2.tabTitle"),
            description: t("servicePages:part-load-booking.features.partLoadFeatures.data_2.description"),
            image: `blue_truck_with_transporter_list.png`,
            altText: "truck with transporter list"
        },
        {
            id: 2,
            tabTitle: t("servicePages:part-load-booking.features.partLoadFeatures.data_3.tabTitle"),
            description: t("servicePages:part-load-booking.features.partLoadFeatures.data_3.description"),
            image: `truck_revenue_increase.png`,
            altText: "truck with growing revenue graph"
        }
    ];
    return partLoadFeatures;
};

export const useFullLoadFeatures = () => {
    const { t } = useTranslation("servicePages");
    const fullLoadFeatures = [
        {
            id: 0,
            tabTitle: t("servicePages:full-load-booking.features.fullLoadFeatures.data_1.tabTitle"),
            description: t("servicePages:full-load-booking.features.fullLoadFeatures.data_1.description"),
            image: `blue_truck.png`,
            altText: "blue truck"
        },
        {
            id: 1,
            tabTitle: t("servicePages:full-load-booking.features.fullLoadFeatures.data_2.tabTitle"),
            description: t("servicePages:full-load-booking.features.fullLoadFeatures.data_2.description"),
            image: `blue_truck_with_forklift.png`,
            altText: "blue truck with loads and forklift"
        },
        {
            id: 2,
            tabTitle: t("servicePages:full-load-booking.features.fullLoadFeatures.data_3.tabTitle"),
            description: t("servicePages:full-load-booking.features.fullLoadFeatures.data_3.description"),
            image: `mobile_mockup_load_postings.png`,
            altText: "mobile mockup with load postings"
        }
    ];
    return fullLoadFeatures;
};

export const useLogisticsFeatures = () => {
    const { t } = useTranslation("servicePages");
    const platformStatLabels = getPlatformStatI18nLabels();
    const logisticsFeatures = [
        {
            id: 0,
            tabTitle: t(
                "servicePages:logistics-services.features.logisticsFeatures.data_1.tabTitle",
                platformStatLabels
            ),
            description: t("servicePages:logistics-services.features.logisticsFeatures.data_1.description"),
            image: `ShipPANIndia-1X-Web.png`,
            altText: "india map with markers"
        },
        {
            id: 1,
            tabTitle: t("servicePages:logistics-services.features.logisticsFeatures.data_2.tabTitle"),
            description: t("servicePages:logistics-services.features.logisticsFeatures.data_2.description"),
            image: `three_blue_trucks.png`,
            altText: "three blue trucks"
        },
        {
            id: 2,
            tabTitle: t("servicePages:logistics-services.features.logisticsFeatures.data_3.tabTitle"),
            description: t("servicePages:logistics-services.features.logisticsFeatures.data_3.description"),
            image: `no-commissions-truck-booking-app_desktop.png`,
            altText: "0% commissions"
        }
    ];
    return logisticsFeatures;
};
export const useGrowFeatures = () => {
    const { t } = useTranslation("servicePages");

    const growFeatures = [
        {
            id: 0,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_1.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_1.description"),
            image: `connect-with-transport-business_desktop.png`,
            altText: "Connect With Top Transporters"
        },
        {
            id: 1,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_2.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_2.description"),
            image: `gn_gain_credibility_desktop.png`,
            altText: "Gain Credibility"
        },
        {
            id: 2,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_3.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_3.description"),
            image: `scaleyourbusiness-1X-Web.png`,
            altText: "trucks all over India"
        },
        {
            id: 3,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_4.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_4.description"),
            image: `transport-leads-app_desktop.png`,
            altText: "Get More Leads"
        },
        {
            id: 4,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_5.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_5.description"),
            image: `build-transport-brand_desktop.png`,
            altText: "transporter profile"
        },
        {
            id: 5,
            tabTitle: t("servicePages:grow-network.features.growFeatures.data_6.tabTitle"),
            description: t("servicePages:grow-network.features.growFeatures.data_6.description"),
            image: `grow-transport-business_desktop.png`,
            altText: "blue truck with coins and arrow"
        }
    ];
    return growFeatures;
};
export const useOlbFeatures = () => {
    const { t } = useTranslation("servicePages");

    const olbFeatures = [
        {
            id: 0,
            tabTitle: t("servicePages:online-load-booking.features.olbFeatures.data_1.tabTitle"),
            description: t("servicePages:online-load-booking.features.olbFeatures.data_1.description"),
            image: `trusted-transport-services_desktop.png`,
            altText: "a truck with two men shaking hands"
        },
        {
            id: 1,
            tabTitle: t("servicePages:online-load-booking.features.olbFeatures.data_2.tabTitle"),
            description: t("servicePages:online-load-booking.features.olbFeatures.data_2.description"),
            image: `return-truck-loads_desktop.png`,
            altText: "a box with a GPS positioning icon surrouned by a circualr shaped road with trucks"
        },
        {
            id: 2,
            tabTitle: t("servicePages:online-load-booking.features.olbFeatures.data_3.tabTitle"),
            description: t("servicePages:online-load-booking.features.olbFeatures.data_3.description"),
            image: `olb_no_commission_desktop.png`,
            altText: "0% written in big font"
        },
        {
            id: 3,
            tabTitle: t(
                "servicePages:online-load-booking.features.olbFeatures.data_4.tabTitle",
                getPlatformStatI18nLabels()
            ),
            description: t(
                "servicePages:online-load-booking.features.olbFeatures.data_4.description",
                getPlatformStatI18nLabels()
            ),
            image: `find-truck-loads-online_desktop.png`,
            altText: "a truck and a mobile phone"
        },
        {
            id: 4,
            tabTitle: t("servicePages:online-load-booking.features.olbFeatures.data_5.tabTitle"),
            description: t("servicePages:online-load-booking.features.olbFeatures.data_5.description"),
            image: `attach-fleet_desktop.png`,
            altText: "two trucks on two pathways with plants"
        }
    ];
    return olbFeatures;
};
export const useOtbFeatures = () => {
    const { t } = useTranslation("servicePages");

    const otbFeatures = [
        {
            id: 0,
            tabTitle: t("servicePages:online-truck-booking.features.otbFeatures.data_1.tabTitle"),
            description: t("servicePages:online-truck-booking.features.otbFeatures.data_1.description"),
            image: `on-time-truck-booking_desktop.png`,
            altText: "blue truck near a clock"
        },
        {
            id: 1,
            tabTitle: t("servicePages:online-truck-booking.features.otbFeatures.data_2.tabTitle"),
            description: t("servicePages:online-truck-booking.features.otbFeatures.data_2.description"),
            image: `no-commissions-truck-booking-app_desktop.png`,
            altText: "0% commissions"
        },
        {
            id: 2,
            tabTitle: t("servicePages:online-truck-booking.features.otbFeatures.data_3.tabTitle"),
            description: t("servicePages:online-truck-booking.features.otbFeatures.data_3.description"),
            image: `book-load-and-lorry-online_desktop.png`,
            altText: "handshaking over phonecall"
        },
        {
            id: 3,
            tabTitle: t("servicePages:online-truck-booking.features.otbFeatures.data_4.tabTitle"),
            description: t("servicePages:online-truck-booking.features.otbFeatures.data_4.description"),
            image: `transparent-bidding-process_desktop.png`,
            altText: "magnifying glass over a phone"
        },
        {
            id: 4,
            tabTitle: t("servicePages:online-truck-booking.features.otbFeatures.data_5.tabTitle"),
            description: t("servicePages:online-truck-booking.features.otbFeatures.data_5.description"),
            image: `truck-transit-tracking_desktop.png`,
            altText: "phone with messaging pop-ups"
        }
    ];
    return otbFeatures;
};

export const useChooseusFeatures = () => {
    const { t } = useTranslation(["whyChooseUs"]);
    const platformStatLabels = getPlatformStatI18nLabels();

    const chooseusFeatures = [
        {
            id: 0,
            tabTitle: t("features.open_marketplace"),
            description: t("features.open_marketplace_description", platformStatLabels),
            image: `truck-booking-marketplace_desktop.png`,
            altText: "vahak-app-for-trucks-and-loads"
        },
        {
            id: 1,
            tabTitle: t("features.one-on-one_dealings"),
            description: t("features.one-on-one_dealings_description"),
            image: `why_choose_1_on_1_bidding_desktop.png`,
            altText: "0-percent-commission"
        },
        {
            id: 2,
            tabTitle: t("features.get_instant_bids"),
            description: t("features.get_instant_bids_description"),
            image: `why_choose_get_instant_bids_desktop.png`,
            altText: "hand-shake-through-two-phones"
        },
        {
            id: 3,
            tabTitle: t("features.network_of_transporters", platformStatLabels),
            description: t("features.network_of_transporters_description"),
            image: `why_choose_2lakh_desktop.png`,
            altText: "trucks-all-over-india"
        },
        {
            id: 4,
            tabTitle: t("features.easy-to-use_dashboard"),
            description: t("features.easy-to-use_dashboard_description"),
            image: `why_choose_dashboard_desktop.png`,
            altText: "truck-booking-dashboard"
        }
    ];

    return chooseusFeatures;
};

export const useGrowHowItworkData = () => {
    const { t } = useTranslation("servicePages");
    const growHowItworkData = [
        {
            mobileApp: [
                {
                    id: 0,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.mobileApp.title1"),
                    btnURL: "https://6r7cz.app.link/googleplay",
                    image: `online-transport-directory-app_desktop.png`,
                    altText: "Download the Vahak app"
                },
                {
                    id: 1,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.mobileApp.title2"),
                    image: `vahak-transporter-network_desktop.png`,
                    altText: "Click on Network"
                },
                {
                    id: 2,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.mobileApp.title3"),
                    image: `personal-transporter-connections_desktop.png`,
                    altText: "See the number of people visiting their profile and their connections"
                },
                {
                    id: 3,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.mobileApp.title4"),
                    image: `transporter-profile-network-page_desktop.png`,
                    altText: "Press on + Connect to send them a connection request"
                },
                {
                    id: 4,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.mobileApp.title5"),
                    image: `all-transport-business-connections_desktop.png`,
                    altText: "Once they accept it, it'll show up in the All tab"
                }
            ],

            webApp: [
                {
                    id: 0,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.webApp.title1"),
                    image: `vahak-online-transport-directory_desktop.png`,
                    altText: "Click on Transport Directory"
                },
                {
                    id: 1,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.webApp.title2"),
                    image: `truck-load-transporter-directory_mobile.png`,
                    altText:
                        "Here you can see the complete list of transporters listed on Vahak's Transporter Directory"
                },
                {
                    id: 2,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.webApp.title3"),
                    image: `search-transporters-pan-india_desktop.png`,
                    altText:
                        "Use the Filters to refine the list based on your Location, Source City, Destination State or Name (if you already know them)"
                },
                {
                    id: 3,
                    title: t("servicePages:grow-network.HowItWorks.growHowItworkData.webApp.title4"),
                    image: `transporter-profile-card_desktop.png`,
                    altText:
                        "Click on Get Contact Details, to contact a desired Transporter or click on View Profile to view details about the Transporter"
                }
            ]
        }
    ];
    return growHowItworkData;
};
export const useOtbHowItworkData = () => {
    const { t } = useTranslation("servicePages");

    const otbHowItworkData = [
        {
            mobileApp: [
                {
                    id: 0,
                    title: t("servicePages:online-truck-booking.HowItWorks.otbHowItworkData.mobileApp.title1"),
                    btnURL: "https://6r7cz.app.link/googleplay",
                    image: `vahak-transportation-marketplace-app-playstore_desktop.png`,
                    altText: "Vahak Transport Market PlayStore Screen"
                },
                {
                    id: 1,
                    title: t("servicePages:online-truck-booking.HowItWorks.otbHowItworkData.mobileApp.title2"),
                    image: `online-truck-booking-app-vahak_desktop.png`,
                    altText: "Vahak App Load Posting"
                },
                {
                    id: 2,
                    title: t("servicePages:online-truck-booking.HowItWorks.otbHowItworkData.mobileApp.title3"),
                    image: `load-posting-app-vahak_desktop.png`,
                    altText: "Vahak App Lorry Selection"
                },
                {
                    id: 3,
                    title: t("servicePages:online-truck-booking.HowItWorks.otbHowItworkData.mobileApp.title4"),
                    image: `largest-online-truck-booking-market_desktop.png`,
                    altText: "Vahak App Payment Details"
                },
                {
                    id: 4,
                    title: t("servicePages:online-truck-booking.HowItWorks.otbHowItworkData.mobileApp.title5"),
                    image: `add-load-on-vahak-app_desktop.png`,
                    altText: "Vahak App ODC Remarks"
                }
            ],

            webApp: [
                {
                    id: 0,
                    title: "1. Click on the Marketplace tab. Then, click on Book A Lorry.",
                    image: `vahak-transport-marketplace_desktop.png`,
                    altText: "Vahak Live Lorry Marketplace"
                },
                {
                    id: 1,
                    title: "2. Enter your Source Location and Destination.",
                    image: `live-lorry-market-app_desktop.png`,
                    altText: "Vahak Lorry Marketplace Location Selection"
                },
                {
                    id: 2,
                    title: "3. Here, use the filters to find lorries based on your Vehicle Type and Capacity.",
                    image: `lorry-search-filters_desktop.png`,
                    altText: "Vahak Lorry Marketplace Search Filters"
                },
                {
                    id: 3,
                    title: "4. Select your desired Lorry and click on Bid Now. Fill the bidding details and submit the bid.",
                    image: `bid-on-lorry-vahak_desktop.png`,
                    altText: "Vahak Lorry Marketplace Bidding"
                }
            ]
        }
    ];
    return otbHowItworkData;
};

export const useOlbHowItworkData = () => {
    const { t } = useTranslation("servicePages");

    const olbHowItworkData = [
        {
            mobileApp: [
                {
                    id: 0,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.mobileApp.title1"),
                    btnURL: "https://6r7cz.app.link/googleplay",
                    image: `online-load-booking-app-vahak_desktop.png`,
                    altText: "Download the Vahak App"
                },
                {
                    id: 1,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.mobileApp.title2"),
                    image: `attach-lorry-to-vahak-app_desktop.png`,
                    altText: "Go to My Lorry and Click on Attach Lorry"
                },
                {
                    id: 2,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.mobileApp.title3"),
                    image: `manage-fleet-on-vahak-app_desktop.png`,
                    altText: "Select Lorry Type and Enter your Lorry Details"
                },
                {
                    id: 3,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.mobileApp.title4"),
                    image: `upload-lorry-documents_desktop.png`,
                    altText: "Add Fleet Routes and Upload Lorry Documents (optional)"
                },
                {
                    id: 4,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.mobileApp.title5"),
                    image: `attach-fleet-to-vahak_desktip.png`,
                    altText: "Click on Attach Fleet"
                }
            ],

            webApp: [
                {
                    id: 0,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.webApp.title1"),
                    image: `olb_howitworkWeb_2_desktop.png`,
                    altText: "Click on the Marketplace tab. Then, click on Find A Load"
                },
                {
                    id: 1,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.webApp.title2"),
                    image: `olb_howitworkWeb_3_desktop.png`,
                    altText: "Enter your Source Location and Destination"
                },
                {
                    id: 2,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.webApp.title3"),
                    image: `olb_howitworkWeb_4_desktop.png`,
                    altText: "Here, use the filters to find loads based on your Vehicle Type and Capacity"
                },
                {
                    id: 3,
                    title: t("servicePages:online-load-booking.HowItWorks.olbHowItworkData.webApp.title4"),
                    image: `bid-on-load_desktop.png`,
                    altText:
                        "Select your desired Load and click on Bid Now. Fill the bidding details and submit the bid"
                }
            ]
        }
    ];

    return olbHowItworkData;
};

export const partLoadHowItworkData = [
    {
        mobileApp: [
            {
                id: 0,
                title: "1. Download the Vahak App.",
                btnURL: "https://6r7cz.app.link/googleplay",
                srcset: `${IMG_BASE_URL}/online-load-booking-app-vahak_desktop_3x.png 1254w, ${IMG_BASE_URL}/online-load-booking-app-vahak_desktop_2x.png 836w, ${IMG_BASE_URL}/online-load-booking-app-vahak_desktop.png 418w, ${IMG_BASE_URL}/online-load-booking-app-vahak_mobile_3x.png 493w, ${IMG_BASE_URL}/online-load-booking-app-vahak_mobile_2x.png 329w, ${IMG_BASE_URL}/online-load-booking-app-vahak_mobile.png 165w`,
                image: `${IMG_BASE_URL}/online-load-booking-app-vahak_mobile.png`,
                altText: "Download the Vahak App"
            },
            {
                id: 1,
                title: "2. Go to Marketplace",
                srcset: `${IMG_BASE_URL}/attach-lorry-to-vahak-app_desktop_3x.png 1254w, ${IMG_BASE_URL}/attach-lorry-to-vahak-app_desktop_2x.png 836w, ${IMG_BASE_URL}/attach-lorry-to-vahak-app_desktop.png 418w, ${IMG_BASE_URL}/attach-lorry-to-vahak-app_mobile_3x.png 493w, ${IMG_BASE_URL}/attach-lorry-to-vahak-app_mobile_2x.png 329w, ${IMG_BASE_URL}/attach-lorry-to-vahak-app_mobile.png 165w`,
                image: `${IMG_BASE_URL}/attach-lorry-to-vahak-app_mobile.png`,
                altText: "Go to Marketplace"
            },
            {
                id: 2,
                title: "3. Click on Load Market",
                srcset: `${IMG_BASE_URL}/manage-fleet-on-vahak-app_desktop_3x.png 1254w, ${IMG_BASE_URL}/manage-fleet-on-vahak-app_desktop_2x.png 836w, ${IMG_BASE_URL}/manage-fleet-on-vahak-app_desktop.png 418w, ${IMG_BASE_URL}/manage-fleet-on-vahak-app_mobile_3x.png 493w, ${IMG_BASE_URL}/manage-fleet-on-vahak-app_mobile_2x.png 329w, ${IMG_BASE_URL}/manage-fleet-on-vahak-app_mobile.png 165w`,
                image: `${IMG_BASE_URL}/manage-fleet-on-vahak-app_mobile.png`,
                altText: "Click on Load Market"
            },
            {
                id: 3,
                title: "4. Browse through 1000+ loads",
                srcset: `${IMG_BASE_URL}/upload-lorry-documents_desktop_3x.png 1254w, ${IMG_BASE_URL}/upload-lorry-documents_desktop_2x.png 836w, ${IMG_BASE_URL}/upload-lorry-documents_desktop.png 418w, ${IMG_BASE_URL}/upload-lorry-documents_mobile_3x.png 493w, ${IMG_BASE_URL}/upload-lorry-documents_mobile_2x.png 329w, ${IMG_BASE_URL}/upload-lorry-documents_mobile.png 165w`,
                image: `${IMG_BASE_URL}/upload-lorry-documents_mobile.png`,
                altText: "Browse through 1000+ loads"
            },
            {
                id: 4,
                title: "5. Press Book Now on your preferred load",
                srcset: `${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_3x.png 1254w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_2x.png 836w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip.png 418w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_3x.png 493w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_2x.png 329w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png 165w`,
                image: `${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png`,
                altText: "Press Book Now on your preferred load"
            },
            {
                id: 5,
                title: "6. Send your Bid across",
                srcset: `${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_3x.png 1254w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_2x.png 836w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip.png 418w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_3x.png 493w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_2x.png 329w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png 165w`,
                image: `${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png`,
                altText: "Send your Bid across"
            },
            {
                id: 6,
                title: "7. You will get responses in 10-15 minutes!",
                srcset: `${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_3x.png 1254w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip_2x.png 836w, ${IMG_BASE_URL}/attach-fleet-to-vahak_desktip.png 418w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_3x.png 493w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile_2x.png 329w, ${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png 165w`,
                image: `${IMG_BASE_URL}/attach-fleet-to-vahak_mobile.png`,
                altText: "You will get responses in 10-15 minutes!"
            }
        ],

        webApp: [
            {
                id: 0,
                title: "1. Click on the Marketplace tab. Then, click on Find A Load.",
                srcset: `${IMG_BASE_URL}/olb_howitworkWeb_2_desktop_3x.png 1873w, ${IMG_BASE_URL}/olb_howitworkWeb_2_desktop_2x.png 1249w, ${IMG_BASE_URL}/olb_howitworkWeb_2_desktop.png 625w, ${IMG_BASE_URL}/olb_howitworkWeb_2_mobile_3x.png 900w, ${IMG_BASE_URL}/olb_howitworkWeb_2_mobile_2x.png 600w, ${IMG_BASE_URL}/olb_howitworkWeb_2_mobile.png 300w`,
                image: `${IMG_BASE_URL}/olb_howitworkWeb_2_mobile.png`,
                altText: "Click on the Marketplace tab. Then, click on Find A Load"
            },
            {
                id: 1,
                title: "2. Enter your Source Location and Destination.",
                srcset: `${IMG_BASE_URL}/olb_howitworkWeb_3_desktop_3x.png 1873w, ${IMG_BASE_URL}/olb_howitworkWeb_3_desktop_2x.png 1249w, ${IMG_BASE_URL}/olb_howitworkWeb_3_desktop.png 625w, ${IMG_BASE_URL}/olb_howitworkWeb_3_mobile_3x.png 900w, ${IMG_BASE_URL}/olb_howitworkWeb_3_mobile_2x.png 600w, ${IMG_BASE_URL}/olb_howitworkWeb_3_mobile.png 300w`,
                image: `${IMG_BASE_URL}/olb_howitworkWeb_3_mobile.png`,
                altText: "Enter your Source Location and Destination"
            },
            {
                id: 2,
                title: "3. Here, use the filters to find loads based on your Vehicle Type and Capacity.",
                srcset: `${IMG_BASE_URL}/olb_howitworkWeb_4_desktop_3x.png 1873w, ${IMG_BASE_URL}/olb_howitworkWeb_4_desktop_2x.png 1249w, ${IMG_BASE_URL}/olb_howitworkWeb_4_desktop.png 625w, ${IMG_BASE_URL}/olb_howitworkWeb_4_mobile_3x.png 900w, ${IMG_BASE_URL}/olb_howitworkWeb_4_mobile_2x.png 600w, ${IMG_BASE_URL}/olb_howitworkWeb_4_mobile.png 300w`,
                image: `${IMG_BASE_URL}/olb_howitworkWeb_4_mobile.png`,
                altText: "Here, use the filters to find loads based on your Vehicle Type and Capacity"
            },
            {
                id: 3,
                title: "4. Select your desired Load and click on Bid Now. Fill the bidding details and submit the bid.",
                srcset: `${IMG_BASE_URL}/bid-on-load_desktop_3x.png 1873w, ${IMG_BASE_URL}/bid-on-load_desktop_2x.png 1249w, ${IMG_BASE_URL}/bid-on-load_desktop.png 625w, ${IMG_BASE_URL}/bid-on-load_mobile_3x.png 900w, ${IMG_BASE_URL}/bid-on-load_mobile_2x.png 600w, ${IMG_BASE_URL}/bid-on-load_mobile.png 300w`,
                image: `${IMG_BASE_URL}/bid-on-load_mobile.png`,
                altText: "Select your desired Load and click on Bid Now. Fill the bidding details and submit the bid"
            }
        ]
    }
];

export const useLoadTypesData = () => {
    const { t } = useTranslation("servicePages");

    const loadTypesData = [
        {
            id: 0,
            type: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.description"),
            image: `steel-load_desktop.jpg`,
            altText: "rolls of steel plates",
            btnURL: `${ROUTES.marketplace.getUrl("load")}`,
            count: 8320,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.state2")
                },
                {
                    image: `chhattisgarh_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.state3")
                }
            ]
        },
        {
            id: 1,
            type: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_2.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_2.description"),
            image: `cement-load_desktop.jpg`,
            altText: "cement bags",
            btnURL: `${ROUTES.marketplace.getUrl("load")}`,
            count: 7775,
            topStates: [
                {
                    image: `jharkhand_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_2.state1")
                },
                {
                    image: `chhattisgarh_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_2.state2")
                },
                {
                    image: `olb_west_bengal_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_2.state3")
                }
            ]
        },
        {
            id: 2,
            type: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_3.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_3.description"),
            image: `carton-box-load_desktopn.jpg`,
            btnURL: `${ROUTES.marketplace.getUrl("load")}`,
            altText: "a cartoon box",
            count: 6003,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_3.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_3.state2")
                },
                {
                    image: `haryana_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_3.state3")
                }
            ]
        },
        {
            id: 3,
            type: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_4.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_4.description"),
            image: `vegetables-load_desktop.jpg`,
            btnURL: `${ROUTES.marketplace.getUrl("load")}`,
            altText: "image of spices and vegetables",
            count: 5002,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_4.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_4.state2")
                },
                {
                    image: `uttar-pradesh_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_4.state3")
                }
            ]
        },
        {
            id: 4,
            type: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_5.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_5.description"),
            image: `chemical-powder-load_desktop.jpg`,
            altText: "a hand holding a chemical powder in a glass plate",
            btnURL: `${ROUTES.marketplace.getUrl("load")}`,
            count: 3838,
            topStates: [
                {
                    image: `rajasthan_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_5.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_5.state2")
                },
                {
                    image: `olb_west_bengal_desktop.png`,
                    state: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_5.state3")
                }
            ]
        }
    ];
    return loadTypesData;
};

export const useLorryTypesData = () => {
    const { t } = useTranslation("servicePages");

    const lorryTypesData = [
        {
            id: 0,
            type: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_1.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.description"),
            image: `container-truck-India_desktop.jpg`,
            altText: "Eicher container truck",
            btnURL: `${ROUTES.marketplace.getUrl("lorry")}?p=1&l=container`,
            count: PLATFORM_STATS.dailyActiveLoads.label,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_1.state1")
                },
                {
                    image: `haryana_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_1.state2")
                },
                {
                    image: `haryana_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_1.state3")
                }
            ]
        },
        {
            id: 1,
            type: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_2.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.description"),
            image: `transport-truck-India_desktop.jpg`,
            altText: "Orange truck",
            btnURL: `${ROUTES.marketplace.getUrl("lorry")}?p=1&l=truck`,
            count: PLATFORM_STATS.tripsCompleted.label,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_2.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_2.state2")
                },
                {
                    image: `uttar-pradesh_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_2.state3")
                }
            ]
        },
        {
            id: 2,
            type: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_3.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.description"),
            image: `LCV-truck-India_desktop.jpg`,
            altText: "TATA White LCV",
            btnURL: `${ROUTES.marketplace.getUrl("lorry")}?p=1&l=lcv`,
            count: PLATFORM_STATS.liveLoadsAndLorries.label,
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_3.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_3.state2")
                },
                {
                    image: `uttar-pradesh_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_3.state3")
                }
            ]
        },
        {
            id: 3,
            type: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_4.type"),
            description: t("servicePages:online-load-booking.TypesOfLoads.loadTypesData.type_1.description"),
            image: `tanker-truck-India_desktop.jpg`,
            altText: "White tanker truck",
            btnURL: `${ROUTES.marketplace.getUrl("lorry")}?p=1&l=tanker`,
            count: "2000+",
            topStates: [
                {
                    image: `maharashtra_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_4.state1")
                },
                {
                    image: `gujarat_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_4.state2")
                },
                {
                    image: `uttar-pradesh_desktop.png`,
                    state: t("servicePages:online-truck-booking.TypesOfLorries.lorryTypesData.type_4.state3")
                }
            ]
        }
    ];
    return lorryTypesData;
};

export const useOtbServiceFeature = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Trucks of various dimensions and load capacities"
        },
        {
            id: 2,
            title: "",
            description: "Ability to undertake transportation for complicated routes and schedules"
        },
        {
            id: 3,
            title: "",
            description: "Every transporter, agent, and truck owner featured in Vahak are Aadhar & GST verified"
        },
        {
            id: 4,
            title: "",
            description: `Find trucks from ${PLATFORM_STATS.locations.label} locations in India`
        },
        {
            id: 5,
            title: "",
            description: `Choose from ${PLATFORM_STATS.verifiedTrucks.lakhsLongPlural} transportation firms, wholesalers, agencies, small lorry proprietors, and consigners`
        },
        {
            id: 6,
            title: "",
            description: "Absolutely free logistics marketplace with zero commission and zero hidden charges"
        },
        {
            id: 7,
            title: "",
            description: "User-friendly dashboard"
        },
        {
            id: 8,
            title: "",
            description: "Competitive rates"
        },
        {
            id: 9,
            title: "",
            description: "Live tracking"
        },
        {
            id: 10,
            title: "",
            description: "Easy return loads availability"
        }
    ];
};

export const useStepsHowToStartBusiness = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Prepare a business plan (capital investment, potential expenses, etc.)"
        },
        {
            id: 2,
            title: "",
            description: "Choose the suitable vehicles for your transportation business (e.g. LCV, containers, trucks)"
        },
        {
            id: 3,
            title: "",
            description: "Purchase a fleet of trucks or a single one based on your budget"
        },
        {
            id: 4,
            title: "",
            description: "Sort out the legal matters (e.g. GST registration, company registration, licences)"
        },
        {
            id: 5,
            title: "",
            description: "Map out your preferred transport routes"
        },
        {
            id: 6,
            title: "",
            description: "Find loads online with Vahak"
        },
        {
            id: 7,
            title: "",
            description: "Connect with transporters pan-India and grow"
        }
    ];
};
export const useStepsHowToMakeBusinessSuccessful = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Users can connect with each other through the transport directory"
        },
        {
            id: 2,
            title: "",
            description: "Since Vahak’s service is free, users can save a lot of money"
        },
        {
            id: 3,
            title: "",
            description: "Prices are fixed and completely transparent. What users see is what they pay."
        },
        {
            id: 4,
            title: "",
            description: "Maximise profit by booking part load and utilising the truck's empty space."
        }
    ];
};

export const usePlbServiceFeature = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Cost-effective transportation solution"
        },
        {
            id: 2,
            title: "",
            description: "Pay only for the space you need"
        },
        {
            id: 3,
            title: "",
            description: "More flexible than full truckload services"
        },
        {
            id: 4,
            title: "",
            description: "Ideal for businesses with smaller shipments"
        },
        {
            id: 5,
            title: "",
            description: "Improved efficiency and resource optimization"
        }
    ];
};
export const usePlTPros = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Ideal for businesses with smaller shipments"
        },
        {
            id: 2,
            title: "",
            description: "Cost-effective, as you only pay for the space you need"
        },
        {
            id: 3,
            title: "",
            description: "More flexible than full truckload services"
        },
        {
            id: 4,
            title: "",
            description: "Reduced risk of damage during transit"
        },
        {
            id: 5,
            title: "",
            description: "Improved efficiency and resource optimization"
        }
    ];
};
export const useFlTPros = () => {
    return [
        {
            id: 1,
            title: "",
            description: "Ideal for businesses with larger shipments"
        },
        {
            id: 2,
            title: "",
            description: "May be more cost-effective for full truckload shipments"
        },
        {
            id: 3,
            title: "",
            description: "Less flexible than part load services"
        },
        {
            id: 4,
            title: "",
            description: "Higher risk of damage during transit"
        },
        {
            id: 5,
            title: "",
            description: "May require more resources and planning"
        }
    ];
};
